module.exports = __webpack_public_path__ + "img/empty.39754c5b.png";